// extracted by mini-css-extract-plugin
export default {"contentArea":"ContentArea_contentArea__a1nzk","expanded":"ContentArea_expanded__8rtwm"};